import { Route } from 'vue-router';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import { loanResolver } from '@/loan/routing/resolvers/loan';
import { loanDetailsResolver } from '@/loan/routing/resolvers/loan-details';
import { sessionResolver } from '@/core/routing/resolvers/session';
import CoreStore from '@/core/store';

const coreStore = getModule(CoreStore, store);

export const loanCoreResolver = async (to: Route): Promise<void> => {
	const { isInitialized } = coreStore;

	await Promise.all([
		sessionResolver(),
		loanDetailsResolver(to),
		loanResolver(to),
	]);

	if (isInitialized) {
		return;
	}

	coreStore.setIsInitialized(true);
};
